import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  viewer: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/viewer.vue").then(m => m.default || m))
}